import axios from '@/api/http';
import base from '@/api//base';
const finance = {
	// 分页请求所有数据-支出订单
	ExpendituresOrderPage(params){
		return axios.post(`${base.baseURL}/ExpendituresOrder/page`,params);
	},
	// 新增数据-支出订单
	ExpendituresOrderInsert(params){
		return axios.post(`${base.baseURL}/ExpendituresOrder/insert`,params);
	},
	// 修改数据-支出订单
	ExpendituresOrderUpdate(params){
		return axios.post(`${base.baseURL}/ExpendituresOrder/update`,params);
	},
	// 删除数据-支出订单
	ExpendituresOrderDeleteById(id){
		return axios.post(`${base.baseURL}/ExpendituresOrder/delete/${id}`);
	},
	// 支出订单生成订单号
	ExpendituresOrderGenerateOrderNo() {
		return axios.get(`${base.baseURL}/ExpendituresOrder/generateOrderNo`);
	},

	// 分页请求所有数据-营收订单
	RevenueOrderPage(params){
		return axios.post(`${base.baseURL}/RevenueOrder/page`,params);
	},
	// 新增数据-营收订单
	RevenueOrderInsert(params){
		return axios.post(`${base.baseURL}/RevenueOrder/insert`,params);
	},
	// 修改数据-营收订单
	RevenueOrderUpdate(params){
		return axios.post(`${base.baseURL}/RevenueOrder/update`,params);
	},
	// 删除数据-营收订单
	RevenueOrderDeleteById(id){
		return axios.post(`${base.baseURL}/RevenueOrder/delete/${id}`);
	},
	// 营收订单生成订单号
	RevenueOrderGenerateOrderNo() {
		return axios.get(`${base.baseURL}/RevenueOrder/generateOrderNo`);
	},

  // 订单数量统计(某年某月按照天分组)-订单统计
  FinancialStatisticSelectOrderNumByYearAndMonth(year, month){
  	return axios.get(`${base.baseURL}/FinancialStatistic/selectOrderNumByYearAndMonth?year=${year}&month=${month}`);
  },
  // 订单数量统计(某年按照月分组)-订单统计
  FinancialStatisticSelectOrderNumByYear(year){
  	return axios.get(`${base.baseURL}/FinancialStatistic/selectOrderNumByYear?year=${year}`);
  },
  // 订单数量统计(照年分组)-订单统计
  FinancialStatisticSelectOrderNum(){
  	return axios.get(`${base.baseURL}/FinancialStatistic/selectOrderNum`);
  },
  // 财务统计 统计收入，支出，利润
  FinancialStatisticSelectAmountByYearAndMonth(params){
    if(params){
      return axios.get(`${base.baseURL}/FinancialStatistic/selectAmountByYearAndMonth?year=${params.year}&month=${params.month}`);
    }else{
      return axios.get(`${base.baseURL}/FinancialStatistic/selectAmountByYearAndMonth`);
    }
  },
}
export default finance;



// WEBPACK FOOTER //
// ./src/network/finance.js